import React, { useCallback } from "react";

import { ProgressiveImage } from "../ProgressiveImage/ProgressiveImage";

// Hooks
import useTheme from "../ThemeProvider/useTheme/useTheme";

const BarImg = ({
  className,
  style,
  imgStyle,
  imgUrl,
  doNotPreload,
  index,
  onClick,
}) => {
  const { theme } = useTheme();

  const handleClick = useCallback(() => {
    onClick && onClick(index);
  }, [index]);

  return (
    <div
      className={`${className} tbk-cursor-pointer tbk-overflow-hidden tbk-object-cover`}
      style={style}
      onClick={handleClick}
    >
      <ProgressiveImage
        className="tbk-relative tbk-h-full tbk-w-full"
        src={imgUrl}
        theme={theme}
        imgConfig={[
          {
            breakpoint: "xs",
            url: imgUrl,
          },
        ]}
        doNotPreload={doNotPreload}
        defaultBreakpoint="xs"
        imgStyle={{
          width: "100%",
          height: "100%",
          ...imgStyle,
        }}
        intersectionThreshold={0.1}
      />
    </div>
  );
};

const MovingBar = ({
  className,
  imgClassName,
  imgStyle,
  images,
  doNotPreload,
  onClick,
}) => (
  <div
    className={`${
      className ? className : ""
    } tb-moving-bar space-around full tbk-flex tbk-min-w-0 tbk-shrink-0 tbk-animate-move-left tbk-items-center tbk-justify-between`}
  >
    {images.map(({ url, height }, index) => (
      <BarImg
        className={imgClassName}
        imgStyle={imgStyle}
        style={{ height }}
        imgUrl={url}
        doNotPreload={doNotPreload}
        index={index}
        onClick={onClick}
      />
    ))}
  </div>
);

export default MovingBar;
